export default {
      id: "ic-soc-instagram-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-soc-instagram-usage",
      toString: function () {
        return this.url;
      }
    }